(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'Chamado'];

    function UserManagementDetailController ($stateParams, User, Chamado) {
        var vm = this;

        vm.load = load;
        vm.getFilaDescricao = getFilaDescricao;
        vm.user = {};
        vm.situacoesPorCodigo = {};

        Chamado.getSituacoes({}, function (data) {
            angular.forEach(data, function (situacao) {
                vm.situacoesPorCodigo[situacao.codigo] = situacao.descricao;
            });
        });

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }

        function getFilaDescricao(codigo) {
            return vm.situacoesPorCodigo[codigo] || codigo;
        }
    }
})();
